var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "template-card-v2",
    {
      attrs: {
        "one-log": _vm.oneLog,
        linkedtype: _vm.linkedtype,
        linkedid: _vm.linkedid,
        "has-history": false
      }
    },
    [
      _c(
        "template",
        { slot: "label" },
        [
          _c("person-list-light", {
            attrs: {
              list: [_vm.contact],
              placeholder: _vm.oneLog.staffs.params.placeholder
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "icon" },
        [_c("CompassObject", { attrs: { object: "tracking", size: "small" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex-column flex-top mt-2 hp-10 lh-20 fs-3",
          attrs: { slot: "content" },
          slot: "content"
        },
        [
          _vm.isForm
            ? [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$l10n.__("A soumis le formulaire:")) +
                      "\n                "
                  ),
                  _c("span", { staticClass: "semibold" }, [
                    _vm._v(
                      _vm._s(_vm.tracking.form_id) +
                        " - " +
                        _vm._s(_vm.tracking.form_name)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$l10n.__("Depuis:")) + "\n                "
                  ),
                  _c(
                    "a",
                    { attrs: { href: _vm.tracking.url, target: "_blank" } },
                    [_vm._v(_vm._s(_vm.tracking.url))]
                  )
                ])
              ]
            : _c("p", { staticClass: "m-0 wp-9 ellipsis" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$l10n.__("A visité:")) +
                    "\n            "
                ),
                _c(
                  "a",
                  { attrs: { href: _vm.tracking.url, target: "_blank" } },
                  [_vm._v(_vm._s(_vm.tracking.url))]
                )
              ])
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "linked" }, slot: "linked" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }